import { Theme } from "@mui/material/styles";
import { HMO } from "constants/hmo";
import { detectHmo } from "utils/hmoDetection";

interface Styles {
  [key: string]: any;
}

const isLeumit = detectHmo() === HMO.LEUMIT;

export const styles = (theme: Theme): Styles => ({
  timerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full,
    padding: `${theme.spacing.spacing6} ${theme.spacing.spacing10} ${theme.spacing.spacing6} ${theme.spacing.spacing10}`,
    backgroundColor: isLeumit
      ? (theme.palette.background as any).soft
      : (theme.palette.background as any).primary,
    borderRadius: theme.borders.borderRadius.xl,
  },
  timer: {
    fontSize: theme.typography.size.size25,
    lineHeight: "147%",
    ...(isLeumit && {
      fontWeight: 500,
    }),
  },
});
